// ORIGINAL ETAPA 4 EXTRA (reduce unused JS — lazy load):
// class SafeLoadScripts extends HTMLElement {
//   constructor() { super(); }
//   connectedCallback() {
//     const scripts = this.querySelectorAll('safe-load-scripts > script');
//     scripts.forEach((script) => {
//       const key = script.dataset.flowLoadKey;
//       const scriptLoaded = window.wetheme.webcomponentRegistry.checkScriptLoaded(key);
//       if(!scriptLoaded) {
//         const postLoadedScript = document.createElement('script');
//         const {src, defer, async, type} = script;
//         postLoadedScript.src = src;
//         postLoadedScript.defer = defer;
//         postLoadedScript.async = async;
//         postLoadedScript.type = type;
//         this.parentElement.appendChild(postLoadedScript);
//       }
//     })
//   }
// }
// customElements.define('safe-load-scripts', SafeLoadScripts);

// ETAPA 9 (reaplicada): adicionados modos data-lazy-on-scroll e data-lazy-on-interaction.
// NÃO usados para search (search-button é <a href> — navegação padrão do browser acontece
// antes do script carregar em mobile/desktop). Usados em back-to-top e localization-form.

class SafeLoadScripts extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const isLazy = this.dataset.lazy === 'true';
    const lazyOnScroll = this.dataset.lazyOnScroll === 'true';
    const lazyOnInteraction = this.dataset.lazyOnInteraction;

    if (lazyOnScroll) {
      this._observeScroll();
    } else if (lazyOnInteraction) {
      this._observeInteraction(lazyOnInteraction);
    } else if (isLazy && 'IntersectionObserver' in window) {
      this._observe();
    } else {
      this._loadScripts();
    }
  }

  _observe() {
    // O alvo do observer precisa ter caixa de layout. Um irmão com display:none
    // (ex.: a navegação .small-hide do slider, escondida no mobile) nunca
    // intersecta, então o observer jamais dispara e o script nunca carrega —
    // era isso que impedia o swipe dos carrosséis no mobile. Se o irmão não
    // estiver renderizado, cai para o parentElement, que sempre tem caixa.
    const hasBox = (el) => el && el.getClientRects().length > 0;
    const target = hasBox(this.nextElementSibling) ? this.nextElementSibling : this.parentElement;
    if (!target) {
      this._loadScripts();
      return;
    }

    const io = new IntersectionObserver((entries, obs) => {
      if (entries[0] && entries[0].isIntersecting) {
        obs.disconnect();
        this._loadScripts();
      }
    }, { rootMargin: '400px 0px' });

    io.observe(target);
  }

  _observeScroll() {
    const load = () => this._loadScripts();
    window.addEventListener('scroll', load, { once: true, passive: true });
  }

  _observeInteraction(selector) {
    const targets = document.querySelectorAll(selector);
    if (!targets.length) {
      // Fallback: selector não encontrou elemento → carrega imediatamente para não perder funcionalidade
      this._loadScripts();
      return;
    }
    const events = ['mouseenter', 'focus', 'click', 'touchstart'];
    let loaded = false;
    const loadOnce = () => {
      if (loaded) return;
      loaded = true;
      this._loadScripts();
    };
    targets.forEach((target) => {
      events.forEach((ev) => target.addEventListener(ev, loadOnce, { once: true, passive: ev !== 'click' }));
    });
  }

  _loadScripts() {
    const scripts = this.querySelectorAll('safe-load-scripts > script');

    scripts.forEach((script) => {
      const key = script.dataset.flowLoadKey;
      const scriptLoaded = key && window.wetheme.webcomponentRegistry.checkScriptLoaded(key);

      if (!scriptLoaded) {
        const postLoadedScript = document.createElement('script');
        const src = script.src || script.dataset.src;
        const type = script.getAttribute('type') || script.dataset.type;

        postLoadedScript.src = src;
        postLoadedScript.defer = script.defer;
        postLoadedScript.async = script.async;
        if (type) postLoadedScript.type = type;

        this.parentElement.appendChild(postLoadedScript);
      }
    });
  }
}

customElements.define('safe-load-scripts', SafeLoadScripts);
